// AJAXify native filter and pagination using Section Rendering API
(function() {
  function onNavigate(url) {
    const sectionId = document.querySelector('[data-section-id]')?.getAttribute('data-section-id');
    if (!sectionId) { window.location.href = url; return; }
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    document.body.classList.add('is-loading');
    fetch(fetchUrl.toString())
      .then(r => r.text())
      .then(html => {
        // Create a DOM from the returned HTML
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const incoming = tmp.querySelector('#category-items-' + sectionId);
        const current = document.querySelector('#category-items-' + sectionId);
        if (incoming && current) {
          // Preserve the current items per page selection
          const currentItemsSelect = current.querySelector('#items-select');
          const incomingItemsSelect = incoming.querySelector('#items-select');
          const currentItemsValue = currentItemsSelect ? currentItemsSelect.value : 'all';
          
          // Replace only the products grid and pagination, and the filters counts
          const incomingGrid = incoming.querySelector('.category-products-grid');
          const currentGrid = current.querySelector('.category-products-grid');
          if (incomingGrid && currentGrid) currentGrid.replaceWith(incomingGrid);

          const incomingPagination = incoming.querySelector('.pagination-container');
          const currentPagination = current.querySelector('.pagination-container');
          if (incomingPagination && currentPagination) currentPagination.replaceWith(incomingPagination);

          const incomingFilters = incoming.querySelector('.filters-sidebar');
          const currentFilters = current.querySelector('.filters-sidebar');
          if (incomingFilters && currentFilters) {
            // Preserve mobile modal state before replacing
            const wasModalActive = currentFilters.classList.contains('active');
            currentFilters.replaceWith(incomingFilters);
            
            // Restore mobile modal state if it was active
            if (wasModalActive) {
              const newFilters = current.querySelector('.filters-sidebar');
              const overlay = current.querySelector('.filter-overlay');
              if (newFilters && overlay) {
                newFilters.classList.add('active');
                overlay.classList.add('active');
                document.body.style.overflow = 'hidden';
              }
            }
          }
          
          // Restore the items per page selection
          const newItemsSelect = current.querySelector('#items-select');
          if (newItemsSelect && incomingItemsSelect) {
            newItemsSelect.value = currentItemsValue;
            // Update the currentItemsPerPage variable
            if (currentItemsValue === 'all') {
              currentItemsPerPage = 1000;
            } else {
              currentItemsPerPage = parseInt(currentItemsValue);
            }
            
            // Only apply client-side pagination if we're not using native filters
            const hasNativeFilters = current.querySelectorAll('.js-filter-link').length > 0;
            if (!hasNativeFilters) {
              updateClientSidePagination();
            }
          }
        }
        window.history.pushState({}, '', url);
      })
      .catch(() => { window.location.href = url; })
      .finally(() => { document.body.classList.remove('is-loading'); });
  }

  // Intercept filter link clicks
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a.js-filter-link');
    if (link) {
      e.preventDefault();
      onNavigate(link.getAttribute('href'));
    }
    // Intercept pagination buttons that are anchors
    const paginationLink = e.target.closest('.pagination a');
    if (paginationLink) {
      e.preventDefault();
      onNavigate(paginationLink.getAttribute('href'));
    }
  });

  // Handle back/forward navigation
  window.addEventListener('popstate', function() {
    const url = window.location.href;
    const sectionId = document.querySelector('[data-section-id]')?.getAttribute('data-section-id');
    if (!sectionId) { window.location.reload(); return; }
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', sectionId);
    fetch(fetchUrl.toString())
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const incoming = tmp.querySelector('#category-items-' + sectionId);
        const current = document.querySelector('#category-items-' + sectionId);
        if (incoming && current) {
          // Preserve the current items per page selection
          const currentItemsSelect = current.querySelector('#items-select');
          const incomingItemsSelect = incoming.querySelector('#items-select');
          const currentItemsValue = currentItemsSelect ? currentItemsSelect.value : 'all';
          
          const incomingGrid = incoming.querySelector('.category-products-grid');
          const currentGrid = current.querySelector('.category-products-grid');
          if (incomingGrid && currentGrid) currentGrid.replaceWith(incomingGrid);
          const incomingPagination = incoming.querySelector('.pagination-container');
          const currentPagination = current.querySelector('.pagination-container');
          if (incomingPagination && currentPagination) currentPagination.replaceWith(incomingPagination);
          const incomingFilters = incoming.querySelector('.filters-sidebar');
          const currentFilters = current.querySelector('.filters-sidebar');
          if (incomingFilters && currentFilters) {
            // Preserve mobile modal state before replacing
            const wasModalActive = currentFilters.classList.contains('active');
            currentFilters.replaceWith(incomingFilters);
            
            // Restore mobile modal state if it was active
            if (wasModalActive) {
              const newFilters = current.querySelector('.filters-sidebar');
              const overlay = current.querySelector('.filter-overlay');
              if (newFilters && overlay) {
                newFilters.classList.add('active');
                overlay.classList.add('active');
                document.body.style.overflow = 'hidden';
              }
            }
          }
          
          // Restore the items per page selection
          const newItemsSelect = current.querySelector('#items-select');
          if (newItemsSelect && incomingItemsSelect) {
            newItemsSelect.value = currentItemsValue;
            // Update the currentItemsPerPage variable
            if (currentItemsValue === 'all') {
              currentItemsPerPage = 1000;
            } else {
              currentItemsPerPage = parseInt(currentItemsValue);
            }
            // Only apply client-side pagination if not using native filters
            const hasNativeFilters = current.querySelectorAll('.js-filter-link').length > 0;
            if (!hasNativeFilters) {
              updateClientSidePagination();
            }
          }
        }
      })
      .catch(() => window.location.reload());
  });
})();
